import BaseListPresenter from "../../../base/BaseListPresenter";
import { dialog } from "nq-component";
import DeleteModal from "../../../components/common/DeleteModal";
import ClusterFormPage from "../../OrganizationaStructure/clusters/cluster-form/ClusterFormPage";
import {
  isAddendumBackPayItem,
} from "../../Finance/Payroll/helper-payroll/constants/payrollConstants";

class OtherDeductionPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["accTitleRelation.accountsTitle", "employmentTypes"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      // this.objects = this.objects.concat(objects);
      this.objects = objects;
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.view.setSelected([]);
    this.findObjects();
  }

  onSelectAll(checked) {
    if (checked) {
      this.view.setSelected([...this.objects]);
    } else {
      this.view.setSelected([]);
    }
  }

  onSelect(index) {
    const selectedObjects = this.view.getSelected();
    const selected = this.objects[index];
    const i = selectedObjects.indexOf(selected);
    if (i > -1) {
      selectedObjects.splice(i, 1);
    } else {
      selectedObjects.push(selected);
    }
    this.view.setSelected(selectedObjects);
  }

  async getGenerateCSV() {
    const { selected } = this.view.state;

    if (!selected?.length) return;

    const accountTitleNames = selected.flatMap(
      (item) =>
        item?.accTitleRelation
          ?.map((rel) => rel?.accountsTitle?.name)
          .filter(Boolean) || []
    );

    const [pTypes, eTypes, pItems] = selected.reduce(
      (
        [payrollType, employmentType, payItem],
        { payrollTypes, employmentTypes, payItems }
      ) => [
        [...payrollType, payrollTypes],
        [...employmentType, employmentTypes?.name || ""],
        [...payItem, payItems],
      ],
      [[], [], []]
    );

    const uniqueEmpTypes = new Set(
      pTypes.map((type, index) => `${type}-${eTypes[index]}-${pItems[index]}`)
    );

    if (uniqueEmpTypes.size > 1) {
      this.view.showError(
        "Please select entries with the same Employment Type and Payroll Templates."
      );
      return;
    }

    const [{ payrollTypes, employmentTypes, payItems }] = selected;
    const addWithholdingCols =
      payrollTypes === "Basic Pay" &&
      employmentTypes?.name === "Job Order" &&
      payItems === "Salary";

      const isBasicBackPay = payrollTypes === "Basic Pay" && isAddendumBackPayItem(payItems);

    const csvHeader = [
      "Agency Employee No.",
      "Name",
      ...(
        addWithholdingCols
          ? ["2%", "5%", "10%"]
          : !isBasicBackPay
            ? ["Tax"]
            : []
      ),
      ...accountTitleNames,
    ].join(",");

    let csvContent = `${csvHeader}\n`;

    const rawFileName =
      uniqueEmpTypes.size > 0 ? [...uniqueEmpTypes][0] : "other_deduction_export";
    const safeFileName = String(rawFileName).replace(/[/\\:*?"<>|]/g, "-");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${safeFileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  handleDeleteData(data) {
    DeleteModal(async () => {
      await this.deleteObjectUseCase.execute("other_deductions", data.id);
      this.view.refetchData();
      dialog.close();
      this.view.showSuccess("Record Deleted Succesfully!");
    });
  }
}
export default OtherDeductionPresenter;
